import type { ApiErrorResponse, ModelSummaryResponse, PredictionResponse } from "../types/api";

async function parseError(response: Response): Promise<Error> {
  try {
    const payload = (await response.json()) as ApiErrorResponse;
    return new Error(payload.error?.message || "Unexpected API error.");
  } catch {
    return new Error(`Request failed with status ${response.status}.`);
  }
}

export async function fetchModelSummary(signal?: AbortSignal): Promise<ModelSummaryResponse> {
  const response = await fetch("/api/model-summary", { signal });
  if (!response.ok) {
    throw await parseError(response);
  }
  return (await response.json()) as ModelSummaryResponse;
}

export async function predictImage({
  image,
  filename,
  source
}: {
  image: Blob;
  filename: string;
  source: "original" | "edited";
}): Promise<PredictionResponse> {
  const formData = new FormData();
  formData.append("image", image, filename);
  formData.append("source", source);
  formData.append("client_meta", JSON.stringify({ source }));

  const response = await fetch("/api/predict", {
    method: "POST",
    body: formData
  });

  if (!response.ok) {
    throw await parseError(response);
  }

  return (await response.json()) as PredictionResponse;
}
